import { render, staticRenderFns } from "./AdditionalInfoDialog.vue?vue&type=template&id=ca6adf80&scoped=true&"
import script from "./AdditionalInfoDialog.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoDialog.vue?vue&type=style&index=0&id=ca6adf80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6adf80",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QItem,QItemSection,QItemLabel,QCardActions,QBtn});
